import React from "react";
import { QrCode, FileText, RefreshCw } from "lucide-react";
import { Factures } from "./Cartes";
import { Groupe, Ligne, TitreGroupe } from "./ui";

const francs = (n) => `CHF ${Number(n || 0).toFixed(2)}`;
const jour = (iso) => String(iso || "").slice(0, 10).split("-").reverse().join(".");

/* Mes factures. Le solde en grand tout en haut : c'est l'information qu'on vient
   chercher. Et l'explication du QR-code juste après, parce que personne ne devine qu'il
   faut le scanner dans son app bancaire. */
export const TabFactures = ({ moi, onAttestation }) => {
  const du = moi.a_payer > 0.5;
  return (
    <div className="space-y-5" data-testid="espace-tab-factures">
      <div className="rounded-[22px] p-5"
        style={du
          ? { background: "#FFFBEB", border: "1px solid #FDE68A" }
          : { background: "#F0FDF4", border: "1px solid #BBF7D0" }}
        data-testid={du ? "espace-solde-resume" : "espace-solde-payee"}>
        <div className="eyebrow" style={{ color: du ? "#B45309" : "#15803D" }}>
          {du ? "Reste à payer" : "Tout est réglé"}
        </div>
        <div className="font-display text-4xl mt-2 font-mono tracking-tight"
          style={{ color: du ? "#B45309" : "#15803D" }}>
          {du ? francs(moi.a_payer) : "Merci !"}
        </div>
        {du && (
          <p className="text-xs text-[var(--muted)] mt-3 flex items-start gap-2">
            <QrCode size={14} className="shrink-0 mt-0.5" />
            Touche ta facture ci-dessous, puis scanne le QR-code avec ton application
            bancaire : le montant et le destinataire se remplissent tout seuls.
          </p>
        )}
        {/* Un virement n'apparaît qu'une fois le relevé bancaire passé par l'école : la
            date dit jusqu'où les paiements sont connus, pour qu'on ne s'inquiète pas d'un
            « reste à payer » déjà réglé (école, 16.10.2026). */}
        {du && moi.paiements_a_jour_le && (
          <p className="text-xs text-[var(--muted)] mt-2 flex items-start gap-2"
            data-testid="espace-paiements-a-jour">
            <RefreshCw size={14} className="shrink-0 mt-0.5" />
            <span>
              Paiements enregistrés jusqu'au <strong>{jour(moi.paiements_a_jour_le)}</strong>.
              Tu as payé après cette date ? Pas d'inquiétude : ton paiement apparaîtra ici
              dès qu'il sera enregistré.
            </span>
          </p>
        )}
      </div>

      <section>
        <TitreGroupe>Mes factures</TitreGroupe>
        <Factures factures={moi.factures} />
      </section>

      {/* Les attestations de paiement (assurance maladie) : à côté des factures, parce
          qu'on les cherche au même moment — quand on fait ses comptes. */}
      {moi.enfants.some((e) => e.cours.length || e.attestations?.length) && (
        <section data-testid="espace-factures-attestations">
          <TitreGroupe>Attestations de paiement</TitreGroupe>
          <Groupe>
            {moi.enfants.filter((e) => e.cours.length || e.attestations?.length).flatMap((e) => (
              e.attestations?.length ? e.attestations.map((a, n) => (
                <Ligne key={`${e.id}-${n}`} Icone={FileText} couleur="#16A34A"
                  titre={`Attestation de ${e.prenom}`}
                  sousTitre={`${a.libelle} · pour l'assurance maladie (PDF)`}
                  onClick={() => onAttestation({ ...e, attestation_lien: a.lien })}
                  testId={`espace-factures-attestation-${e.id}${n ? `-${n}` : ""}`} />
              )) : [(
                /* La vraie raison (paiement pas encore reçu, numéro AVS manquant…), pas
                   un message générique qui laissait attendre une famille sans AVS. */
                <Ligne key={e.id} Icone={FileText} couleur="#CBD5E1" titre={`Attestation de ${e.prenom}`}
                  sousTitre={e.attestation_motif || "Disponible dès qu'un paiement est enregistré"}
                  fleche={false} testId={`espace-factures-attestation-${e.id}`} />
              )]
            ))}
          </Groupe>
        </section>
      )}
    </div>
  );
};
